import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Button, TextField, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ConfirmationPopup } from '../../../../app/components';
import Section from '../Section';
import { loadTexts } from '../../../../config/texts';

import { onError } from '../../../app_state/actions';
import { fetchUser } from '../../../auth/actions';
import { updateOrganizationSplitCharge, organizationStripeLoginLink } from '../../actions';

import { getNetworkInfo, getStripeInfo } from '../../../../util/network';
import { getAdminToken } from '../../../../config/localstore';
const TEXT_KEY = "organization";

const styles = theme => ({
  container: {
    padding: theme.spacing.unit * 2,
    // display: 'flex',
    // flexDirection: 'column',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  createStripeButton: {
    marginTop: theme.spacing.unit * 2,
  },
});

class PaymentSettings extends React.Component {
  state = {
    splitCharge: (get(this, 'props.organization.payment.split_charge') || 0) / 100,
    showPopup: false,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  }

  componentDidMount() {
    window.onfocus = () => {
      this.props.fetchUser();
    };
  }

  componentWillUnmount() {
    window.onfocus = null;
  }

  _onSave = async () => {
    const { splitCharge, texts: { error } } = this.state;

    // multiply by 100 for backend
    const chargeConverted = splitCharge * 100;
    if (!Number.isInteger(chargeConverted)) {
      this.props.onError({ message: error.price_format });
      return;
    }

    await this.props.updateOrganizationSplitCharge({
      organization: this.props.organization._id,
      amount: chargeConverted,
    });

    this.props.fetchUser();
  };

  _onCancel = () => {
    this.setState({
      splitCharge: (get(this, 'props.organization.payment.split_charge') || 0 ) / 100,
    });
  };

  _onClickChange = () => this.setState({ showPopup: true });
  _onCloseChange = () => this.setState({ showPopup: false });

  _onClickConnect = async () => {
    const token = await getAdminToken();
    const { tp, domain, endpoints: { stripe: se } } = getNetworkInfo();
    const redirect = `${tp}${domain}${se}/organization`;
    // console.log(redirect)
    const { currency } = this.props.organization;
    const { oauth, client_id: client } = getStripeInfo(currency);
    const link = `${oauth}redirect_uri=${redirect}&client_id=${client}&state=${currency}|${token}|${this.props.selectedOrganization}`;
    window.open(link);
  };

  _onClickViowDashboard = async () => {
    await this.props.organizationStripeLoginLink({ organization: this.props.selectedOrganization });

    if (this.props.dashboardLink && typeof this.props.dashboardLink === 'string')
      window.open(this.props.dashboardLink);
  };

  renderContent = () => {
    const { texts: { stripe } } = this.state;
    const stripeId = get(this, 'props.organization.payment.stripe_id');
    return (
      <div>
        <Typography gutterBottom>
          {stripe.standard_mode}
        </Typography>
        <Typography gutterBottom>
          {stripe.manual_mode}
        </Typography>
        <Typography gutterBottom>
          {stripe.split_mode}
        </Typography>
        <Typography color="secondary">
          {stripe.instruction}
        </Typography>
        {!stripeId && (
          <Button
            color="primary"
            variant="contained"
            target="_blank"
            onClick={this._onClickConnect}
            className={this.props.classes.createStripeButton}
          >
            {stripe.button_text}
          </Button>
        )}
      </div>
    );
  };

  render() {
    const { splitCharge, showPopup, texts } = this.state;
    const { classes, organization } = this.props;
    const payment = get(organization, 'payment') || {};

    const saveDisabled = splitCharge != splitCharge
      || splitCharge === (get(payment, 'split_charge') || 0) / 100;

    return (
      <Section
        onCancel={this._onCancel}
        onSave={this._onSave}
        saveDisabled={saveDisabled}
        cancelDisabled={false}
      >
        <div className={classes.container}>
          <div className={classes.buttonContainer}>
            <Typography gutterBottom>
              {`${texts.section.payment_mode} ${payment.mode}`}
            </Typography>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={this._onClickChange}
            >
              {texts.button_text.change_mode}
            </Button>
          </div>
          {payment.mode === 'split' && (
            <TextField
              id="split_charge"
              label={`${texts.label.amount} (ex: 10.00)`}
              // check for NaN
              value={splitCharge != splitCharge ? '' : splitCharge}
              onChange={event => this.setState({ splitCharge: parseFloat(event.target.value) })}
              type="number"
            />
          )}
          {payment.stripe_id && (
            <Button
              color="primary"
              variant="contained"
              target="_blank"
              onClick={this._onClickViowDashboard}
            >
              {texts.button_text.view_dashboard}
            </Button>
          )}
        </div>
        <ConfirmationPopup
          open={showPopup}
          noCancel
          affirmativeButtonText={texts.pop_up.button_text}
          onClose={this._onCloseChange}
          onSubmit={this._onCloseChange}
          subtitle={texts.pop_up.subtitle}
          title={texts.pop_up.title}
          content={this.renderContent}
        />
      </Section>
    );
  }
}

export default compose(
  withStyles(styles, { name: 'PaymentSettings' }),
  connect(
    state => {
      const selectedOrganization = get(state, 'auth.selectedOrganization');
      const organizations = get(state, 'auth.data.user.organizations') || [];
      return {
        selectedOrganization,
        organization: organizations.find(o => o._id === selectedOrganization),
        dashboardLink: get(state, 'organization.link.data'),
        locale: state.appState.locale
      };
    },
    dispatch => ({
      onError: params => dispatch(onError(params)),
      fetchUser: params => dispatch(fetchUser()()),
      updateOrganizationSplitCharge: params => dispatch(updateOrganizationSplitCharge(params)()),
      organizationStripeLoginLink: params => dispatch(organizationStripeLoginLink(params)()),
    })
  )
)(PaymentSettings);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/PaymentSettings/index.js